import times from 'lodash/times'
import {
  decomposeColor,
  recomposeColor
} from '@material-ui/core/styles/colorManipulator'

/**
 * this function inverts the given color
 * @param {string} - color - the color string to invert, in RGB format (#rrggbb, rgb(r,g,b) or rgba(r,g,b,a)
 * @return {string} - the inverted color, as an rgb() or rgba() string
 */
export function invertColor(color: string): string {
  const invertedColor = decomposeColor(color)
  if (invertedColor.type.includes('rgb')) {
    times(3).forEach((i: number): void => {
      invertedColor.values[i] = 255 - invertedColor.values[i]
    })
  }
  return recomposeColor(invertedColor)
}

export default invertColor
